module.exports = __webpack_public_path__ + "media/images/logo/logo-5d0a9f74f76482049bb8cb3eaf0ac845.png";